import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { RedeemBonusCodeComponent } from './redeem-bonus-code.component';


@NgModule({
  declarations: [
    RedeemBonusCodeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
  ]
})
export class RedeemBonusCodeModule { }